module.exports = __webpack_public_path__ + "static/media/13.06bc7d23.jpg";